import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';


export const CreateTagValidation = () => {

    return yup.object().shape({
        name: yup.string().required(ERRORS.required),
        tagID: yup.string().required(ERRORS.required),
        status: yup.bool().required(ERRORS.required),
        groupId: yup.string().optional(),
        chargingType: yup.string().required(ERRORS.required),
        vehicleBatteryCap: yup.number().min(0).required(ERRORS.required),
        vehicleChargingCap: yup.number().min(0).required(ERRORS.required),
    });

}

export const CreateGroupValidation = yup.object().shape({
    name: yup.string().required(ERRORS.required),
    address: yup.string().required(ERRORS.required),
    mode: yup.string().required(ERRORS.required),
    action: yup.bool().required(ERRORS.required),
    installedCapacity: yup
        .number()
        .when("mode", {
            is: (mode) => ["siteLoadManagement", "loadManagement&smartCharge"].includes(mode),
            then: yup.number().required(ERRORS.required),
            otherwise: yup.number().optional(),
        }),

    installedCapacitySignal: yup
        .string()
        .when("mode", {
            is: (mode) => ["siteLoadManagement", "loadManagement&smartCharge"].includes(mode),
            then: yup.string().required(ERRORS.required),
            otherwise: yup.string().optional(),
        }),
});

export const SendProfileValidation = yup.object().shape({
    duration: yup.number().required(ERRORS.required),
});
